// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ForecastUserSchema = z.object({
  id: z.nullable(z.number().int().describe("User ID")),
  email: z.coerce.string().describe("User email"),
  name: z.coerce.string().describe("User name"),
  avatar: z.object({
    large_retina: z.nullable(z.coerce.string().describe("Large retina avatar URL")),
    large: z.nullable(z.coerce.string().describe("Large avatar URL")),
    medium_retina: z.nullable(z.coerce.string().describe("Medium retina avatar URL")),
    medium: z.nullable(z.coerce.string().describe("Medium avatar URL")),
    timeline: z.nullable(z.coerce.string().describe("Timeline avatar URL")),
  }).describe("User avatar URLs"),
  updated_at: z.nullable(z.coerce.string().describe("ISO 8601 timestamp")),
  estimated_minutes: z.optional(z.number().int().describe("Per-user estimated minutes")),
  estimated_duration: z.optional(z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  }).describe("Per-user estimated duration")),
  weekly_capacity: z.optional(z.number().describe("Weekly capacity in hours")),
  work_days: z.coerce.string().describe("Work days configuration").nullish(),
  weekdays: z.coerce.string().describe("Legacy weekdays format").nullish(),
});
